"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionProcessStatus = exports.Origin = exports.ButtonAction = void 0;
let SubscriptionProcessStatus = exports.SubscriptionProcessStatus = /*#__PURE__*/function (SubscriptionProcessStatus) {
  SubscriptionProcessStatus["Initial"] = "Initial";
  SubscriptionProcessStatus["Subscribed"] = "Subscribed";
  SubscriptionProcessStatus["Failed"] = "Failed";
  return SubscriptionProcessStatus;
}({});
let ButtonAction = exports.ButtonAction = /*#__PURE__*/function (ButtonAction) {
  ButtonAction["None"] = "None";
  ButtonAction["Reset"] = "Reset";
  ButtonAction["Submit"] = "Submit";
  return ButtonAction;
}({});
let Origin = exports.Origin = /*#__PURE__*/function (Origin) {
  Origin["OnlineFooter"] = "OnlineFooter";
  Origin["OnlinePopup"] = "OnlinePopup";
  return Origin;
}({});